/// <amd-module name="TFS/CreateProject/Sources/DataProviderSource" />
import { Constants } from "TFS/CreateProject/Constants";
import { ICollectionProjectNamesData, IProjectCreationMetadata } from "TFS/CreateProject/Contracts";
import * as CreateProjectResources from "TFS/CreateProject/Resources";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import * as VSS_Trace from "VSS/Platform/Trace";

export class DataProviderSource {
    constructor(private _pageContext: IVssPageContext) {}

    /**
     * Fetches, deserializes and constructs the project creation metadata from the data provider
     * @param forceRequest - Optional flag. If true, a network call is made irrespective of data available in json island.
     */
    public getInitialData(forceRequest?: boolean): Promise<IProjectCreationMetadata | undefined> {
        const performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        const scenarioName = "CreateProjectPanel.DataProviderSource.GetInitialData";
        performanceService.startScenario(scenarioName, false);

        return this._pageContext
            .getService<IVssContributionService>("IVssContributionService")
            .getDataAsync<IProjectCreationMetadata | undefined>(Constants.ProjectCreationDataProvider, undefined, forceRequest)
            .then(
                (response: IProjectCreationMetadata | undefined) => {
                    performanceService.endScenario(Constants.Area, scenarioName, false);
                    return response;
                },
                (error: Error) => {
                    performanceService.endScenario(Constants.Area, scenarioName, false, undefined, { status: "failed" });
                    VSS_Trace.traceError(
                        this._pageContext,
                        Constants.Area,
                        "CreateProjectPanel.DataProviderSource.GetInitialData.Failed",
                        error.message,
                        { error: error }
                    );

                    throw new Error(CreateProjectResources.CreateProjectGenericServerErrorText);
                }
            );
    }

    /**
     * Fetches list of existing project names from the data provider
     */
    public getExistingProjects(): Promise<ICollectionProjectNamesData | undefined> {
        const performanceService = this._pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        const scenarioName = "CreateProjectPanel.DataProviderSource.GetExistingProjects";
        performanceService.startScenario(scenarioName, false);

        return this._pageContext
            .getService<IVssContributionService>("IVssContributionService")
            .getDataAsync<ICollectionProjectNamesData>(Constants.ProjectNamesDataProvider, undefined, true)
            .then(
                (response: ICollectionProjectNamesData | undefined) => {
                    performanceService.endScenario(Constants.Area, scenarioName, false);
                    return response;
                },
                (error: Error) => {
                    performanceService.endScenario(Constants.Area, scenarioName, false, undefined, { status: "failed" });
                    VSS_Trace.traceError(
                        this._pageContext,
                        Constants.Area,
                        "CreateProjectPanel.DataProviderSource.GetExistingProjects.Failed",
                        error.message,
                        { error: error }
                    );

                    // Don't want to throw when fetching existing project names fails
                    return undefined;
                }
            );
    }
}
